export class ThirdLicense {
    constructor(thirdLicenseState) {
        this.thirdLicenseState = thirdLicenseState;
    }
    get id() { return this.thirdLicenseState.id; }
    get third_id() { return this.thirdLicenseState.third_id; }
    get license_type() { return this.thirdLicenseState.license_type; }
    get exp_date() { return this.thirdLicenseState.exp_date; }
    get license_name() { return this.thirdLicenseState.license_name; }
    set third_id(value) { this.thirdLicenseState.third_id = value; }
    set license_type(value) { this.thirdLicenseState.license_type = value; }
    set exp_date(value) { this.thirdLicenseState.exp_date = value; }
    getState() { return this.thirdLicenseState; }
}
